import React, { ReactNode } from "react";

interface LinhaTabelaProps {
  children: ReactNode;
  id: string;
  className?: string;
  style?: object;
  isSelecionada?: boolean;
}

export const LinhaTabela: React.FC<LinhaTabelaProps> = (props) => {
  let className = "tr-gc";
  if (props.isSelecionada) {
    className += " linha-selecionada ";
  }
  if (props.className) {
    className += props.className;
  }

  return (
    <tr key={`linha-tabela-${props.id}`} id={props.id} className={className}>
      {props.children}
    </tr>
  );
};
